var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('cabecalho'),_c('breadcrumb')],1),_c('div',[_c('div',{staticClass:"areaRenderizaPaginas"},[_c('router-view',{ref:"corpoGeralPaginas"})],1)]),_c('div',{staticClass:"backgroundLogin"})])}
var staticRenderFns = []

export { render, staticRenderFns }